import React from 'react';
import logo from '../img/logo.png';

function NavBarFixed() {
  // const logo = 'font-playfair-display';
  return (
    <header className="fixed w-full bg-neutral-50 shadow-md py-4 z-10">
      <div className="flex items-center justify-center px-6">
        <a href="/"><img src={logo} alt="Logo" className='h-14' /></a>
      </div>
    </header>
  );
}

export default NavBarFixed;